export const MIN_PASSWORD_LENGTH = 8;
export const PASSWORD_HELP_TEXT = `Lozinka mora imati najmanje ${MIN_PASSWORD_LENGTH} karaktera.`;

const normalize = (value) => (value || '').trim().toLowerCase();

export function validatePassword(password, { username, email } = {}) {
  if (!password || password.length < MIN_PASSWORD_LENGTH) {
    return PASSWORD_HELP_TEXT;
  }

  const trimmedPassword = password.trim();
  if (!trimmedPassword) {
    return 'Lozinka ne moze biti prazna ili sastavljena samo od razmaka.';
  }

  if (new Set(trimmedPassword).size === 1) {
    return 'Lozinka ne moze biti sastavljena od jednog ponovljenog karaktera.';
  }

  const normalizedPassword = normalize(password);
  const identifiers = [username, email && email.split('@')[0]].filter(Boolean);
  const hasPersonalInfo = identifiers.some((value) => {
    const normalizedValue = normalize(value);
    return normalizedValue.length >= 4 && normalizedPassword.includes(normalizedValue);
  });

  if (hasPersonalInfo) {
    return 'Lozinka ne smije sadrzavati korisnicko ime ili email.';
  }

  return null;
}
